import { render, staticRenderFns } from "./CenterViewPrintPreview_Ap.vue?vue&type=template&id=2b4f1b1d&scoped=true"
import script from "./CenterViewPrintPreview_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewPrintPreview_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewPrintPreview_Ap.vue?vue&type=style&index=0&id=2b4f1b1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f1b1d",
  null
  
)

export default component.exports